import React from 'react';

const AlertWidget = () => {
    return null;
};

export default AlertWidget;
